import React from 'react';
import ReactDOM from 'react-dom';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Treebeard, theme, decorators } from 'react-treebeard';
import Util from './Util.js';
import {VelocityComponent} from 'velocity-react';

import TreeViewTheme from './TreeViewTheme.js';

//Theme
theme.tree.node.toggle.width = '12';
theme.tree.node.toggle.height = '12';

// Decorator
decorators.Header = ({ style, node, onSelect }) => {
  var customStyle = "";
  
  if (node.decorators){
      customStyle += "treeNodePadding5 ";
  }

  if(node.isUpdate){
    customStyle += "updateNodeTag ";
  }
  else if(node.isNew){
    customStyle += "newNodeTag ";
  }

  if(node.forceIcon){
     customStyle += "treeNodePadding3 ";
  }

  if(node.topTreeNode){
    customStyle += "topTreeNode ";
  }

  return (
    <div style={style.base} onClick={onSelect}>
      <div className={customStyle} style={style.title}>
        {node.forceIcon && <i className={node.forceIcon} aria-hidden="true"></i>}
        {node.name}
      </div>
    </div>
  );
};

decorators.Header.propTypes = {
  onSelect:  PropTypes.func,
  node:  PropTypes.object,
  style:  PropTypes.object
};


decorators.Toggle = ({ node, style, onToggle, animations}) => {
  //const style = props.style;
  return (
    <VelocityComponent animation={animations.toggle.animation} duration={animations.toggle.duration}>
      <div style={style.base} onClick={onToggle}>
        <div style={style.wrapper}>
          <i className={node.active ? "fa fa-chevron-right activedToggle" : "fa fa-chevron-right"} aria-hidden="true"></i>
        </div>
      </div>
    </VelocityComponent> 
  );
};

const Container= (props) => {
  const {style, decorators, terminal, node, customStyles, onClick, onSelect, animations} = props;
  return (
      <div style={node.active ? {...style.container} : {...style.link}}>
          {!terminal ? <decorators.Toggle style={style.toggle} node={node} onToggle={onClick} animations={animations}/> : null}
          <decorators.Header node={node} style={style.header} customStyles={customStyles} onSelect={onSelect}/>
      </div>
  );
}

class TreeView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.onSelect = this.onSelect.bind(this);
    this.onToggle = this.onToggle.bind(this);
  }
  
  onToggle(node, toggled) {
    this.activeSelectedNode(node);
    if (node.children) {
       node.toggled = toggled; 
    }
    this.setState({ cursor: node });
    this.props.setHomeState(false);
  }

  onSelect(node) {
    this.activeSelectedNode(node);
    node.selected = true;
    this.setState({cursor: node});
    this.props.onSelect(node);
  }

  activeSelectedNode(node){
    var pushParams = {
      pathname: window.content_path + node.id
    }
    if (this.props.codeMode == 1) {
      pushParams.search = "?devLang=kotlin"
    }
    this.props.history.push(pushParams);
    if (this.state.cursor) {
      this.state.cursor.active = false;
    }
    else {
      Util.InActiveAll(this.props.data);
    }
    node.active = true;
  }

  render() {
     return  (
      <Treebeard
        data={this.props.data}
        onToggle={this.onToggle}
        onSelect={this.onSelect}
        style={TreeViewTheme}
        decorators={{...decorators, Container}}
      />
      );
  }
}

TreeView.propTypes = {
  // data: React.PropTypes.oneOfType([
  //    React.PropTypes.object,
  //    React.PropTypes.array
  // ]).isRequired,
  serverUrl: PropTypes.string,
  onToggleClick: PropTypes.func
};

export default withRouter(TreeView);
